import { render, staticRenderFns } from "./DownloadableItem.vue?vue&type=template&id=7bd91112&scoped=true"
import script from "./DownloadableItem.vue?vue&type=script&lang=ts"
export * from "./DownloadableItem.vue?vue&type=script&lang=ts"
import style0 from "./DownloadableItem.vue?vue&type=style&index=0&id=7bd91112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd91112",
  null
  
)

export default component.exports